import { usePage } from "@tree-company/tree-query";
import { useEffect } from "react";
import { Progress } from "../components/progress";
import { Steps } from "./steps";
import SurveyNavigation from "./survey_navigation";

export default function SurveyPage({
  page,
  handleSave,
  onPreviousPage,
  children,
}) {
  const { title, description } = usePage(page);

  useEffect(() => {
    const prefersReducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)",
    ).matches;
    window.scrollTo({
      top: 0,
      behavior: prefersReducedMotion ? "instant" : "smooth",
    });
  }, [page.key]);

  return (
    <form action="" className="survey" onSubmit={handleSave}>
      <Steps steps={page.settings.steps} />
      {page.settings.showProgress && <Progress store={page.store} />}
      {(title || description) && (
        <div className="survey__intro">
          <h1 className="survey__title">{title}</h1>
          <p className="survey__description">{description}</p>
        </div>
      )}
      {children}
      <SurveyNavigation onPreviousPage={onPreviousPage} />
    </form>
  );
}
